export default __webpack_public_path__ + "static/media/JS5D.268d7406.jpg";